import {
  BUSINESS_ALLOWED_ROLES,
  BUSINESS_PERMISSIONS,
  normalizeAuthList,
} from "@/constants/businessAccess"

const routePermissions = [
  ["/user-profile/company-settings/messages", BUSINESS_PERMISSIONS.CHAT_MANAGE],
  ["/user-profile/company-settings/report-details", BUSINESS_PERMISSIONS.REPORT_VIEW],
  ["/user-profile/company-settings/reports", BUSINESS_PERMISSIONS.REPORT_VIEW],
  ["/user-profile/company-settings/admin", BUSINESS_PERMISSIONS.ADMIN_MANAGE],
  ["/user-profile/company-settings/reply-comments", BUSINESS_PERMISSIONS.COMMENT_REPLY],
  ["/user-profile/company-settings/appointment", BUSINESS_PERMISSIONS.RESERVATION_MANAGE],
  ["/user-profile/company-settings/information/data", BUSINESS_PERMISSIONS.COMPANY_UPDATE],
  ["/user-profile/company-settings/information/media", BUSINESS_PERMISSIONS.COMPANY_UPDATE],
  ["/user-profile/company-settings/information", BUSINESS_PERMISSIONS.COMPANY_VIEW],
  ["/user-profile/company-settings/discount", BUSINESS_PERMISSIONS.DISCOUNT_MANAGE],
  ["/user-profile/company-settings/service", BUSINESS_PERMISSIONS.SERVICE_MANAGE],
  ["/user-profile/company-settings/unit", BUSINESS_PERMISSIONS.UNIT_MANAGE],
  ["/user-profile/company-settings/blog", BUSINESS_PERMISSIONS.CONTENT_MANAGE],
  ["/user-profile/company-settings", BUSINESS_PERMISSIONS.DASHBOARD_VIEW],
]

export default defineNuxtRouteMiddleware(async to => {
  if (!to.path.startsWith("/user-profile/company-settings")) return

  const session = useAuthSession()
  try { await session.ensure() } catch { /* Keep offline sessions available. */ }
  const token = session.read()?.token
  const roles = normalizeAuthList(session.read()?.role)

  if (!token) {
    return navigateTo({ path: "/user-profile", query: { redirect: to.fullPath, auth: "required" } })
  }

  if (!roles.some(role => BUSINESS_ALLOWED_ROLES.includes(role))) {
    return navigateTo("/user-profile/business-access-denied")
  }

  const permission = routePermissions.find(([prefix]) => to.path.startsWith(prefix))?.[1]
  if (permission) {
    const { can } = useBusinessAccess()
    if (!can(permission)) return navigateTo("/user-profile/business-access-denied")
  }
})
